import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import {
  INVOICES_CREATE,
  INVOICES_UPDATE,
} from "../../auth/permissions";
import CatalogItem from "../../models/catalog-item";
import HasAnyPermissionComponent from "../permissions/HasAnyPermissionComponent";

interface CatalogItemCrudActionsProps {
  catalogItem: CatalogItem;
  onUpdateClick: (_: CatalogItem) => void;
  onDeleteClick: (_: CatalogItem) => void;
}

const MANAGE = [INVOICES_CREATE, INVOICES_UPDATE];

const CatalogItemCrudActions: React.FC<CatalogItemCrudActionsProps> = ({
  catalogItem,
  onUpdateClick,
  onDeleteClick,
}) => {
  return (
    <td className="text-center">
      <HasAnyPermissionComponent permissionNames={MANAGE}>
        <CButtonGroup>
          <CTooltip content={"Editar"}>
            <CButton
              color="warning"
              className="text-white"
              onClick={() => {
                onUpdateClick(catalogItem);
              }}
            >
              <i className="fa fa-pencil"></i>
            </CButton>
          </CTooltip>
          <CTooltip content={"Desactivar"}>
            <CButton
              className="text-white"
              color="danger"
              onClick={() => {
                onDeleteClick(catalogItem);
              }}
            >
              <i className="fa fa-ban"></i>
            </CButton>
          </CTooltip>
        </CButtonGroup>
      </HasAnyPermissionComponent>
    </td>
  );
};

export default CatalogItemCrudActions;
